import { createPortal } from 'react-dom';
import { Flex, Spin as AntSpin } from 'antd';
import type { SpinProps } from 'antd';
import LazySvg from 'components/LazySvg';
import styles from './index.module.scss';

const pageLoaderElement =
  document.getElementById('page-loader') || document.body;

function Loader() {
  return (
    <Flex justify='center' align='center' className='fullHeight'>
      <LazySvg className={styles.loader} name='spinner' />
    </Flex>
  );
}

function Spin(props: SpinProps) {
  return <AntSpin indicator={<Loader />} {...props} />;
}

export function PageLoader() {
  return createPortal(
    <Flex justify='center' align='center' className={styles.pageLoader}>
      <Spin />
    </Flex>,
    pageLoaderElement,
  );
}

export default Spin;
